export default __webpack_public_path__ + "static/media/add-property.png?.1fd231a6";